import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UTILS } from 'src/app/entities/Utils';

@Component({
  selector: 'app-confirm-modal', 
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css']
})
export class ConfirmModalComponent implements OnInit {

  @Input() title: string | undefined;
  @Input() description: string | undefined;
  @Input() si: string | undefined;
  @Input() no: string | undefined;

  conferma: string;
  chiudi: string;

  constructor(public translate: TranslateService, public activeModal: NgbActiveModal) { 
    this.conferma = "";
    this.chiudi = "";
  }

  async ngOnInit(): Promise<void> {
    if (typeof this.si == "undefined" ) {
      this.conferma = await new UTILS().getTranslateTitle(this.translate, "general.confirm");
    } else {
      this.conferma = this.si;
    }
    if (typeof this.no == "undefined" ) {
      this.chiudi = await new UTILS().getTranslateTitle(this.translate, "general.close");
    } else {
      this.chiudi = this.no;
    }
  }

  close(){
    this.activeModal.close(false);
  }

  async confirm(){
    this.activeModal.close(true);
  }

}
